export default function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 py-8 text-text-secondary">
      <span
        className="h-5 w-5 animate-spin rounded-full border-2 border-brand border-t-transparent"
        role="status"
        aria-label={label}
      />
      <span className="text-sm">{label}</span>
    </div>
  )
}
